import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './region-map.module.scss';
import { setActiveRegion } from '../../actions/ui';
import RegionMapBanner from './region-map-banner';
import Map from '../map';
import * as selectors from '../../reducers';

const RegionMap = ({
  council,
  activeDam,
  onCouncilSelect,
  onDamSelect,
}) => {

  return (
    <div
      className={`councilMapWrapper ${styles.councilWrapper}`}
    >
      <RegionMapBanner
        council={council}
      />
      <div className={`${styles.mapWrapper}`}>
        <Map
          council={council}
          onCouncilSelect={onCouncilSelect}
          activeDam={activeDam}
          onDamSelect={onDamSelect}
          scrollZoom={false}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setActiveRegion,
};

const mapStateToProps = (state) => ({
  isMobile: selectors.getIsMobile(state),
});

RegionMap.propTypes = {
  onCouncilSelect: PropTypes.func,
  onDamSelect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionMap);


// WEBPACK FOOTER //
// ./src/components/region-map/region-map.js